import React from 'react'
import Select from 'react-select'
import {isFieldEmpty} from '../../helpers/utils'

const types = {checkbox: Checkbox, textarea: Textarea, panel: Panel, dropdown: Dropdown}


function Dropdown (props) {
  const {name, count, grouped, value, options, context} = props
  const selects = value.filter(val => val != '').map((val, index) => { 
    const label = value.length < 2 ? name : `${name} ${index + 1}`
    return (
      <div key={index} className="select">
        {!grouped && name && (<label>{label}</label>)}
        <div className="control">
          {val || " "}
        </div>
      </div>)
 })
  return (
    <div>
      {grouped && (<label>{name}</label>)}
      {selects}
    </div>
  )
}

function Checkbox (props) {
  const {context} = props
  return (
    <div>
      <label>
        <input
          type="checkbox"
          checked={props.value}
          readOnly={true}
        />
        {props.name}
      </label>
    </div>
  )
}

function Textarea (props) {
  const {context, name, maxlength, value, id, panelId, contentId} = props
  return (
    <div>
      <label>{name}</label>
      <div className="textarea">
        {value}
      </div>
    </div>
  )
}

function Panel (panelProps) {
  const {id, name, context} = panelProps
  const children = panelProps.children
    .map((props, contentId) => ({props, Element: types[props.type], contentId}))
    .filter(({Element, props}) => Element && !isFieldEmpty(props))
    .map(({Element, props, contentId}, index) => (
      <Element
        key={index}
        id={id}
        panelId={panelProps.contentId}
        contentId={contentId}
        context={context}
        {...props}
      />))

  return (
    <div>
      {children.length > 0 && (
        <React.Fragment>
          <label>{name}</label>
          <div className="children">
            {children}
          </div>
        </React.Fragment>)}
    </div>
  )
}

export default types
